module.exports = __webpack_public_path__ + "orangeroom.jpg?523cb0a19d13bf3ec5fe20a743591317";


//////////////////
// WEBPACK FOOTER
// ./src/assets/orangeroom.jpg
// module id = 33
// module chunks = 11